import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {TrendingUp,DateRange,Event,ConfirmationNumber,CompareArrows,AlarmOutlined,AirportShuttleOutlined,SubwayOutlined,Send,AirlineSeatReclineNormal,Money,AirportShuttle,PersonOutlined,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place,WbIncandescentOutlined,ArrowDropDown,DevicesOtherOutlined,AccountBalanceWalletOutlined,ConfirmationNumberOutlined,CancelPresentation} from '@material-ui/icons';

import ScheduleIcon from '@material-ui/icons/Schedule';

import {
  ListItemText,
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Grid,
  Chip,
  Link ,
  useMediaQuery,
  ListItemIcon,
  List,
  ListItem,
  ListSubheader,
  Divider,
  ListItemAvatar,
  Avatar,
  ListItemSecondaryAction
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import { MuiPickersUtilsProvider, DatePicker,TimePicker,KeyboardTimePicker, DateTimePicker} from "@material-ui/pickers";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';


import MaskedInput from "react-text-mask";


import Autocomplete from '@material-ui/lab/Autocomplete';

import UserInfo from "./login_info";

import axios from 'axios';
import Format from "date-fns/format";
import DateFnsUtils from "@date-io/date-fns";

import {TransportService,ReportingService} from "./../../utils/web_config_2";
import { set } from 'date-fns/esm';
import Manifesto from "../../assets/svg/bus-stop.svg";
import bus from "../../assets/svg/bus.svg";
import route from "../../assets/svg/route.svg";

import passenger from "../../assets/svg/passenger_bus.svg";
import money from "../../assets/svg/total_amount.svg";
import iticketdetails from "../../assets/svg/ticket_details.svg";


import trip from "../../assets/svg/trip.svg";

import Chart from 'react-apexcharts';


const useStyles1 = makeStyles((theme) => ({
    root: {
      flexShrink: 0,
      flexFlow:1,
      [theme.breakpoints.up('sm')]:{
        marginLeft:250,
      }
    },
    btn:{
      textTransform:"capitalize",
  
    },
    formTitle:{
      flexGrow:1,
  },paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    elevation:0
  },
  paper1: {
    color: theme.palette.text.secondary,
    height:240,
    elevation:0
  },
  report:{
   
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    '& svg': {
      margin: theme.spacing(1.5),
    },
    '& hr': {
      margin: theme.spacing(0, 0.5),
    },
  }
  }));
  


  const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={inputRef}
        mask={[/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }
  
  TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };
  


function ComparativeReport(){
    const classes = useStyles1();
    const [operatorData, setOperatorData] = useState({});

    useEffect(()=>{

        var data = {};
        const data1 = localStorage.getItem("nx_op");
        if (data1 != null) {
          data = JSON.parse(data1);
        }
    
        setOperatorData(data);
        
        
      },[]);



      const [fromDate,setFromDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
      const [toDate,setToDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});

      const [fromDateB,setFromDateB]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
      const [toDateB,setToDateB]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});


      // query comparative report trip


      const [loading,setLoading]=useState(false);
      const [comparativeReport,setComparativeReport]=useState({});


      const [display,setDisplay]=useState(false);


      const getComparativeReport=()=>{

        setDisplay(false);
        setLoading(true);
        setComparativeReport([]);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const tripInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
        tripInstance.post('/extra-reports/pullComparativeReport',
        {
            "company_id": new UserInfo().ORG_ID,
            "end_date_first_window": toDate.value,
            "start_date_first_window": fromDate.value,
            "end_date_second_window": toDateB.value,
            "start_date_second_window": fromDateB.value
          }).then(res=>{
          setLoading(false);
          console.log("== comparative report ==",res.data);
          let data=res.data.data;
          setComparativeReport(data);
          setDisplay(true);
        
        })
        .catch(err=>{
          setLoading(false);
        });
 
      }


      const [differenceTicketsByCurrency,setDifferenceTicketsByCurrency]=useState({});
      const [differenceAmountByCurrency,setDifferenceAmountByCurrency]=useState({});

      useEffect(()=>{
        setDifferenceTicketsByCurrency(comparativeReport?.difference_tickets_by_currency);
        setDifferenceAmountByCurrency(comparativeReport?.difference_amount_by_currency);
      },[comparativeReport]);


    return (
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<div className={classes.root}>
					<Box display='flex'>
						<Box
							display='flex'
							alignItems='center'
							mt={2}
							className={classes.formTitle}
						>
							<Box mr={1}>
								<CompareArrows color='primary' fontSize='large' />{' '}
							</Box>{' '}
							<Typography variant='h5' color='default'>
								<b>Comparative Report</b>
							</Typography>
						</Box>
					</Box>

					<Box mt={2}>
						<Grid container spacing={1}>
							{/* section A */}

							<Grid item md={4} lg={4} sm={12} xs={12}>
								<Paper className={classes.paper} elevation={0}>
									<Box>
										<Box
											mt={1}
											display='flex'
											alignItems='center'
											justifyContent='center'
										>
											<Grid container>
												<Grid item md={12} lg={12} sm={12} xs={12}>
													<Box>
														<DatePicker
															fullWidth
															disableToolbar
															variant='inline'
															format='yyyy-MM-dd'
															margin='dense'
															disableFuture
															autoOk
															label='Start Date'
															value={fromDate.value}
															inputVariant='outlined'
															onChange={(v) => {
																// console.log("choosen2: ",v);
																setFromDate({
																	value: Format(v, ['yyyy-MM-dd']),
																	error: '',
																});
															}}
															InputProps={{
																disableUnderline: true,
																style: { paddingRight: 1 },
															}}
														/>
													</Box>
												</Grid>
											</Grid>
										</Box>

										<Box
											mt={1}
											display='flex'
											alignItems='center'
											justifyContent='center'
										>
											<Grid container>
												<Grid item md={12} lg={12} sm={12} xs={12}>
													<Box>
														<DatePicker
															fullWidth
															disableToolbar
															variant='inline'
															format='yyyy-MM-dd'
															margin='dense'
															disableFuture
															autoOk
															label='End Date'
															value={toDate.value}
															inputVariant='outlined'
															onChange={(v) => {
																// console.log("choosen2: ",v);
																setToDate({
																	value: Format(v, ['yyyy-MM-dd']),
																	error: '',
																});
															}}
															InputProps={{
																disableUnderline: true,
																style: { paddingRight: 1 },
															}}
														/>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</Box>
								</Paper>
							</Grid>

							{/* compare button  */}

							<Grid item md={4} lg={4} sm={12} xs={12}>
								<Box
									display='flex'
									flexDirection='column'
									justifyItems='center'
									alignItems='center'
								>
									<CompareArrows style={{ fontSize: 80, marginTop: '10px' }} />

									<Box width='60%'>
										<Button
											className={classes.btn}
											ml={10}
											size='small'
											variant='contained'
											color='primary'
											disableElevation
											fullWidth
											disabled={loading}
											onClick={() => {
												getComparativeReport();
											}}
										>
											{loading ? (
												<CircularProgress color='secondary' size={23} />
											) : (
												'Compare'
											)}
										</Button>
									</Box>
								</Box>
							</Grid>

							{/* section B */}

							<Grid item md={4} lg={4} sm={12} xs={12}>
								<Paper className={classes.paper} elevation={0}>
									<Box>
										<Box
											mt={1}
											display='flex'
											alignItems='center'
											justifyContent='center'
										>
											<Grid container>
												<Grid item md={12} lg={12} sm={12} xs={12}>
													<Box>
														<DatePicker
															fullWidth
															disableToolbar
															variant='inline'
															format='yyyy-MM-dd'
															margin='dense'
															disableFuture
															autoOk
															label='Start Date'
															value={fromDateB.value}
															inputVariant='outlined'
															onChange={(v) => {
																// console.log("choosen2: ",v);
																setFromDateB({
																	value: Format(v, ['yyyy-MM-dd']),
																	error: '',
																});
															}}
															InputProps={{
																disableUnderline: true,
																style: { paddingRight: 1 },
															}}
														/>
													</Box>
												</Grid>
											</Grid>
										</Box>

										<Box
											mt={1}
											display='flex'
											alignItems='center'
											justifyContent='center'
										>
											<Grid container>
												<Grid item md={12} lg={12} sm={12} xs={12}>
													<Box>
														<DatePicker
															fullWidth
															disableToolbar
															variant='inline'
															format='yyyy-MM-dd'
															margin='dense'
															disableFuture
															autoOk
															label='End Date'
															value={toDateB.value}
															inputVariant='outlined'
															onChange={(v) => {
																// console.log("choosen2: ",v);
																setToDateB({
																	value: Format(v, ['yyyy-MM-dd']),
																	error: '',
																});
															}}
															InputProps={{
																disableUnderline: true,
																style: { paddingRight: 1 },
															}}
														/>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</Box>
								</Paper>
							</Grid>

							{/* report  */}

							{display && (
								<Grid item md={12} lg={12} sm={12} xs={12}>
									<Paper elevation={0}>
										<Box height='200px' width='100%'>
											<Grid
												container
												alignItems='center'
												className={classes.report}
											>
												<Grid item lg={4} sx={12} sm={12} md={4}>
													<Box style={{ borderRight: 'solid #BDBDBD 1px' }}>
														<List dense={true}>
															<ListItem dense={true}>
																<ListItemText
																	primary={
																		<Typography variant='h6'>
																			Period A
																		</Typography>
																	}
																/>
															</ListItem>
															<ListItem dense={true}>
																<ListItemAvatar>
																	<Event />
																</ListItemAvatar>
																<ListItemText primary='Start Date' />
																<ListItemSecondaryAction>
																	<Typography>{fromDate.value}</Typography>
																</ListItemSecondaryAction>
															</ListItem>
															<ListItem dense={true}>
																<ListItemAvatar>
																	<DateRange />
																</ListItemAvatar>
																<ListItemText primary='End Date' />
																<ListItemSecondaryAction>
																	<Typography>{toDate.value}</Typography>
																</ListItemSecondaryAction>
															</ListItem>
															{comparativeReport?.first_window_results.map(
																(item, index) => (
																	<Box key={index}>		
																			<List>
																				<ListItem dense={true}>
																					<ListItemAvatar>
																						<ConfirmationNumber />
																					</ListItemAvatar>
																					<ListItemText primary='Tickets' />
																					<ListItemSecondaryAction>
																						<Typography>
																							{item.ticket}
																						</Typography>
																					</ListItemSecondaryAction>
																				</ListItem>
																				<ListItem dense={true}>
																					<ListItemAvatar>
																						<Money />
																					</ListItemAvatar>
																					<ListItemText
																						primary='Total Amount'
																						lg={4}
																					/>
																					<ListItemSecondaryAction>
																						<Box
																							display='flex'
																							justifyContent='flex-end'
																							width='150px'
																						>
																							<Typography>
																								{item.amount} {item.currency}
																							</Typography>
																						</Box>
																					</ListItemSecondaryAction>
																				</ListItem>
																			</List>
																		<Divider />
																	</Box>
																)
															)}
														</List>
													</Box>
												</Grid>
												{/* Difference */}
												<Grid item lg={4} sx={12} sm={12} md={4}>
													<Box>
														<Box
															display='flex'
															alignItems='center'
															justifyItems='center'
															justifyContent='center'
														>
															<TrendingUp fontSize='large' />
														</Box>
														<Box
															display='flex'
															alignItems='center'
															justifyItems='center'
															justifyContent='center'
														>
															<Typography variant='h6'>Difference</Typography>
														</Box>
														<Box>
															{Object.keys(differenceTicketsByCurrency).map(
																(currency) => (
																	<Box
																		key={currency}
																		display='flex'
																		flexDirection='column'
																		alignItems='center'
																		mt={2}
																	>
																		<Typography variant='body1'>
																			{currency}
																		</Typography>
																		<Typography variant='body2'>
																			Tickets:{' '}
																			{differenceTicketsByCurrency[currency]}
																		</Typography>
																		<Typography variant='body2'>
																			Amount:{' '}
																			{differenceAmountByCurrency[
																				currency
																			].toFixed(2)}
																		</Typography>
																	</Box>
																)
															)}
														</Box>
													</Box>
												</Grid>
												{/* Period B */}
												<Grid item lg={4} sx={12} sm={12} md={4}>
													<Box style={{ borderLeft: 'solid #BDBDBD 1px' }}>
														<List dense={true}>
															<ListItem dense={true}>
																<ListItemText
																	primary={
																		<Typography variant='h6'>
																			Period B
																		</Typography>
																	}
																/>
															</ListItem>
															<ListItem dense={true}>
																<ListItemAvatar>
																	<Event />
																</ListItemAvatar>
																<ListItemText primary='Start Date' />
																<ListItemSecondaryAction>
																	<Typography>{fromDateB.value}</Typography>
																</ListItemSecondaryAction>
															</ListItem>
															<ListItem dense={true}>
																<ListItemAvatar>
																	<DateRange />
																</ListItemAvatar>
																<ListItemText primary='End Date' />
																<ListItemSecondaryAction>
																	<Typography>{toDateB.value}</Typography>
																</ListItemSecondaryAction>
															</ListItem>
															{comparativeReport?.second_window_results.map(
																(item, index) => (
																	<Box key={index}>																
																			<List>
																				<ListItem dense={true}>
																					<ListItemAvatar>
																						<ConfirmationNumber />
																					</ListItemAvatar>
																					<ListItemText primary='Tickets' />
																					<ListItemSecondaryAction>
																						<Typography>
																							{item.ticket}
																						</Typography>
																					</ListItemSecondaryAction>
																				</ListItem>
																				<ListItem dense={true}>
																					<ListItemAvatar>
																						<Money />
																					</ListItemAvatar>
																					<ListItemText
																						primary='Total Amount'
																					/>
																					<ListItemSecondaryAction>
																						<Box
																							display='flex'
																							justifyContent='flex-end'
																							width='150px'
																						>
																							<Typography>
																								{item.amount} {item.currency}
																							</Typography>
																						</Box>
																					</ListItemSecondaryAction>
																				</ListItem>
																			</List>
																		<Divider />
																	</Box>
																)
															)}
														</List>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</Paper>
								</Grid>
							)}
						</Grid>
					</Box>

					{/* <Grid item md={8} lg={8} sm={12} xs={12}>
         <Paper className={classes.paper} elevation={0}>
              <Box >
          {loading&&<LinearProgress />}
          <MUIDataTable
            data={vehicleTrips}
            columns={columns}
            options={options}
          />
            </Box>
            </Paper>
         </Grid> */}
				</div>
			</MuiPickersUtilsProvider>
		);
}

export default  withLocalize(ComparativeReport);